import { Survey } from "@kaigi100-next/typing";
export function isOtherAnswer(survey: Survey, answer: string) {
  return (
    (survey.answerFormat === "pulldown" || survey.answerFormat === "radio") &&
    survey.choices.findIndex((choice) => choice === answer) === -1
  );
}
